export default "__VITE_ASSET__DZ0nBY7j__"